import { DetailsPolicyActionTypes } from './types';
import { PolicyViewModelResponse } from './model';
import { action } from 'typesafe-actions';

export const fetchPolicyViewModel = (caseCode: string) => action(DetailsPolicyActionTypes.FETCH_POLICY_VIEW_MODEL, { caseCode });
export const fetchPolicyViewModelSuccess = (policyViewModel: PolicyViewModelResponse) => action(DetailsPolicyActionTypes.FETCH_POLICY_VIEW_MODEL_SUCCESS, { policyViewModel });
export const fetchPolicyViewModelError = (message: string) => action(DetailsPolicyActionTypes.FETCH_POLICY_VIEW_MODEL_FAIL, { message });
export const resetDetailsPolicyState = () => action(DetailsPolicyActionTypes.RESET_STATE);
